module.exports = __webpack_public_path__ + "img/312.ff469e23.png";